import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 3v18h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 17V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 17V5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 17v-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BarChart3";
const BarChart3 = memo(themed(Icon));
export {
  BarChart3
};
//# sourceMappingURL=bar-chart-3.js.map
